const getInitState = () => {
  return {
    agreements: [],
    serviceCase: {}
  }
};

export default {
  getInitState
}
